const checkUpsellOnMinicart = () => {
    setTimeout(() => {
        const minicartUpsell = document.querySelector(".js-minicart-upsell");
        if (!minicartUpsell) return;

        fetch(window.Shopify.routes.root + 'cart.js')
        .then(response => {
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            return response.json();
        })
        .then(data => {
            const items = data.items;
            const triggerList = window.upsell?.triggerList || [];
            const foundInCart = triggerList.some(trigger =>
                items.some(item => String(item.product_id) === String(trigger.id))
            );
            console.log(triggerList);
            console.log(items)
            minicartUpsell.classList.toggle("hidden", foundInCart);
            return data;
        })
        .catch(err => console.error("Error fetching cart data:", err));
    }, 1000);
};

document.addEventListener("click", e => {
    const upsellCard = e.target.closest(".js-minicart-upsell-card");
    if (!upsellCard) return;

    if (e.target.closest(".js-quantity-minus")) {
        const productId = upsellCard.getAttribute("data-product-id");
        const variantId = upsellCard.getAttribute("data-variant-id");
        const amount = upsellCard.querySelector(".js-quantity-amount");
        if (!productId || !variantId || !amount) return;

        fetch(window.Shopify.routes.root + 'cart.js')
        .then(res => {
            if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
            return res.json();
        })
        .then(data => {
            const targetItem = data.items.find(item =>
                String(item.product_id) === String(productId) &&
                Number(item.id) === Number(variantId)
            );
            if (!targetItem) {
                console.log("Minicart upsell: Producto no está en el carrito.");
                return;
            }
            const currentQty = Number(targetItem.quantity) || 0;
            const reduceBy = Number(amount.getAttribute("data-amount")) || 1;
            const newQty = currentQty - reduceBy;
            updateUpsellQty(variantId, newQty > 0 ? newQty : 0);
        })
        .catch(err => console.error("Error fetching cart data:", err));
    }

    if (e.target.closest(".js-quantity-plus")) {
        const productId = upsellCard.getAttribute("data-product-id");
        const variantId = upsellCard.getAttribute("data-variant-id");
        const amount = upsellCard.querySelector(".js-quantity-amount");
        if (!productId || !variantId || !amount) return;

        const qtyToAdd = Number(amount.getAttribute("data-amount")) || 1;

        fetch(window.Shopify.routes.root + 'cart.js')
        .then(res => {
            if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
            return res.json();
        })
        .then(data => {
            const totalQty = data.items
                .filter(item => String(item.product_id) === String(productId))
                .reduce((sum, item) => sum + (Number(item.quantity) || 0), 0);
            const limit = Number(window.upsell.productLimit);
            if (totalQty >= limit) {
                console.log("Minicart upsell: Límite alcanzado.");
            } else {
                upsellAddToCart(variantId, qtyToAdd);
            }
        })
        .catch(err => console.error("Error fetching cart data:", err));
    }

    if (e.target.closest(".js-upsell-button-atc")) {
        const productId = upsellCard.getAttribute("data-product-id");
        const variantId = upsellCard.getAttribute("data-variant-id");
        const amount = upsellCard.querySelector(".js-quantity-amount");
        if (!productId || !variantId || !amount) return;

        const qtyToAdd = Number(amount.getAttribute("data-amount")) || 1;

        fetch(window.Shopify.routes.root + 'cart.js')
        .then(res => {
            if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
            return res.json();
        })
        .then(data => {
            const totalQty = data.items
                .filter(item => String(item.product_id) === String(productId))
                .reduce((sum, item) => sum + (Number(item.quantity) || 0), 0);
            const limit = Number(window.upsell.productLimit);
            if (totalQty >= limit) {
                console.log("Minicart upsell: Límite alcanzado.");
            } else {
                upsellAddToCart(variantId, qtyToAdd);
            }
        })
        .catch(err => console.error("Error fetching cart data:", err));
    }
});

const targetNode = document.querySelector('.minicart');
if (targetNode) {
    const config = { attributes: true, attributeFilter: ['data-items-count'] };
    let debounceTimer;

    const callback = mutationsList => {
        for (const mutation of mutationsList) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'data-items-count') {
                clearTimeout(debounceTimer);
                debounceTimer = setTimeout(() => checkUpsellOnMinicart(), 300);
            }
        }
    };

    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
}

function upsellAddToCart(variantId, qty) {
    const formData = {
        items: [{
            id: variantId,
            quantity: qty,
            properties: { _upsell: "true" }
        }]
    };
    fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
    })
    .then(res => {
        if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
        return res.json();
    })
    .then(() => VueMinicart.config.globalProperties.$store.dispatch('initCart'))
    .catch(err => console.error('Error:', err));
}

function updateUpsellQty(variantId, qty) {
    const updates = { [variantId]: qty };
    fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
    })
    .then(res => {
        if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
        return res.json();
    })
    .then(() => VueMinicart.config.globalProperties.$store.dispatch('initCart'))
    .catch(err => console.error('Error:', err));
}

document.addEventListener('cart.initCart', checkUpsellOnMinicart);
document.addEventListener('cart.addItem', checkUpsellOnMinicart);
document.addEventListener('cart.updateItem', checkUpsellOnMinicart);